import { DTOBillingInterval, DTOProductCode, DTOWorkspaceBilledSeatType, DTOWorkspaceRole, } from "./enums";
import z from "zod";
//
// Entities
//
export const DTOProductPrice = z.object({
    isActive: z.boolean(),
    /** @deprecated use `isActive` */
    active: z.boolean(),
    amount: z.number(),
    interval: DTOBillingInterval,
    isPricePerCreator: z.boolean(),
    isTrial: z.boolean(),
    isHidden: z.boolean(),
    legacyVersion: z.string().optional(),
    seatType: DTOWorkspaceBilledSeatType,
    monthlyCreditGrant: z.number(),
    stripePriceId: z.string(),
    stripeProductId: z.string(),
    stripeProductDescription: z.string().optional(),
    stripeProductFeatures: z.string().array().optional(),
    stripeProductAdditionalFeatures: z.string().array().optional(),
});
export const DTOProduct = z.object({
    code: DTOProductCode,
    allowedInviteRoles: DTOWorkspaceRole.array(),
    prices: DTOProductPrice.array(),
});
//
// Responses
//
export const DTOAvailableProductListResponse = z.object({
    availablePlans: DTOProduct.array(),
});
